<template>
  <div :class="width+ ' datepicker_wrapper'">
    <div class="label">
      {{ capitalisedLabel }}
    </div>
    <div
      class="daterange"
      @click.stop="open = !open"
    >
      {{ formattedDate }}
    </div>
    <div
      v-show="open"
      class="calendar_settings_wrapper active"
    >
      <div :id="id+'-date-picker'" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import $ from 'jquery';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Date',
    },
    modelValue: {
      type: String,
      default: moment().format('YYYY-MM-DD')
    },
    minDate: {
      type: String,
      default: new Date()
    },
    width: {
      type: String,
      default: 'full'
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY'
    }
  },
  data() {
    return {
      open: false
    }
  },
  computed: {
    capitalisedLabel() {
      let words = this.label.split(' ');
      _.each(words, (word, index) => {
        words[index] = _.capitalize(word);
      });
      return words.join(' ');
    },
    formattedDate() {
      return moment(this.modelValue).format(this.format);
    }
  },
  watch: {
    minDate() {
      let self = this;
      $(`#${this.id}-date-picker`).datepicker('option', 'minDate', self.minDate);
    }
  },
  mounted() {
    // Self required for datepicker functions
    let self = this;
    $(`#${this.id}-date-picker`).datepicker({
      dateFormat: 'yy-mm-dd',
      defaultDate: new Date(self.modelValue),
      firstDay: 1,
      goToCurrent: true,
      numberOfMonths: 1,
      minDate: self.minDate,
      beforeShowDay: function (date) {
        // Loops through all dates on the calendar, determining if they should be highlighted.
        var fromDate = $.datepicker.parseDate('yy-mm-dd', self.modelValue);
        return [true, date.getTime() == fromDate.getTime() ? "dp-highlight" : ""];
      },
      onSelect: function (dateText) {
        self.$emit('update:modelValue', dateText);
        self.open = false;
      }
    });
  }

}
</script>

<style scoped>
.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.daterange {
  width: 100%;
  color: #4E4E54;
  background-color: #fff;
  border: 1px solid #E8E5E2;
  padding: 14.5px 24.5px 15.5px;
  border-radius: 12px;
  height: 3rem;
  font-size: 14px;
  letter-spacing: -0.5px;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.datepicker_wrapper {
  position: relative;
}

.label {
  margin-bottom: .25rem;
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.calendar_settings_wrapper {
  width: auto;
  margin: 0;
}

.datepicker {
  border: none !important;
  padding: 0 !important;
  margin-bottom: 5px;
}

.date-picker.hasDatepicker {
  margin: 0 !important;
}
</style>
